<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>销售订单使用说明:<br>
					<span>1、物品编号自动生成,构成规则:类型+'XS'+4位顺序号。添加无效</span><br>
					<span>1、提交后为锁定状态,如需修改请先作废。</span><br>
					<span>2、查询关键字:单号、客户、签订日期、车牌、业务员。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button @click="edit_mode_car">车辆照片</button>
				<button @click="edit_mode_client">客户资料</button>
				<button @click="edit_mode_file">销售附件</button>
			</template>
			<template slot="pre_tan_button">
				<button @click="edit_mode_car">车辆照片</button>
				<button @click="edit_mode_client">客户资料</button>
				<button @click="edit_mode_file">销售附件</button>
			</template>

		</pre-base>

		<editmode-tan ref="itemmode"></editmode-tan>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue"),
			"editmode-tan": () => import("../base_tan/tan_car_img.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "sellsheet",
					"title": "销售订单",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_sell_car_sheet',
					"upd_action": 'exp15_sell_car_sheet',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "客户姓名",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "销售汽车",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "销售人员",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_selluser",
							"sel_name": ""
						}
					],
					"parm": [{
							"name": "业务订单",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "签订日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "销售车辆",
							"val": "",
							"key": "car_no",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_sellcar",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "购买客户",
							"val": "",
							"key": "client_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_sellclient",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "成交全款",
							"val": "",
							"key": "sell_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "成交首付",
							"val": "",
							"key": "first_pay",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "成交分期期数",
							"val": "",
							"key": "f_num",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "几号还款",
							"val": "",
							"key": "pay_day",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "年利率",
							"val": "",
							"key": "year_rate",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "成交每期付款",
							"val": "",
							"key": "sell_f_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "预付保证性租金",
							"val": "0",
							"key": "pay_month_more",
							"type": "number",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "首付日期",
							"val": "",
							"key": "first_date",
							"type": "date",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "销售人员",
							"val": "",
							"key": "sell_user",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_selluser",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "是否过户",
							"val": "",
							"key": "is_chang_user",
							"type": "select",
							"class": "long1",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_action": "",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "车架号",
							"val": "",
							"key": "c_frame",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "品牌型号",
							"val": "",
							"key": "c_name",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "所属人",
							"val": "",
							"key": "c_user",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "当前里程",
							"val": "",
							"key": "car_dis",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "动力类型",
							"val": "",
							"key": "car_engin",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "配置",
							"val": "无",
							"key": "car_info",
							"type": "textarea",
							"class": "long4",
							"note": "请输入配置内容...",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "5"
						},
						{
							"name": "营运证注册",
							"val": "",
							"key": "oper_s_date",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "营运证截止",
							"val": "",
							"key": "oper_e_date",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "商业险",
							"val": "",
							"key": "syx_date",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "交强险",
							"val": "",
							"key": "jqx_date",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "全款",
							"val": "",
							"key": "amount",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "首付",
							"val": "",
							"key": "first_pay",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "分期期数",
							"val": "",
							"key": "f_num",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "每期付款",
							"val": "",
							"key": "f_amount",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "7"
						}

					],
					"parm_th": [{
							"name": "序号"
						},

						{
							"name": "业务单号"
						},

						{
							"name": "签订日期"
						},

						{
							"name": "车牌"
						},

						{
							"name": "购买客户"
						},
						{
							"name": "状态"
						},
						{
							"name": "车架号"
						},
						{
							"name": "品牌型号"
						},
						{
							"name": "所属人"
						},
						{
							"name": "当前里程"
						},
						{
							"name": "动力类型"
						},
						{
							"name": "配置"
						},
						{
							"name": "车辆照片"
						},
						{
							"name": "更新日期"
						},
						{
							"name": "营运证注册"
						},
						{
							"name": "营运证截止"
						},
						{
							"name": "商业险"
						},
						{
							"name": "交强险"
						},
						{
							"name": "总金额"
						},
						{
							"name": "是否过户"
						},
						{
							"name": "首付"
						},
						{
							"name": "分期期数"
						},
						{
							"name": "几号还款"
						},
						{
							"name": "年利率"
						},
						{
							"name": "每期金额"
						},
						{
							"name": "预付保证金租金"
						},
						{
							"name": "首付日期"
						},
						{
							"name": "备注"
						},
						{
							"name": "成交全款"
						},
						{
							"name": "成交首付"
						},
						{
							"name": "分期期数"
						},

						{
							"name": "成交分期金额"
						},
						{
							"name": "销售人员"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [],
					"d_name": []

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode_car: function() {

				let sheet_no = '',
					flag = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'car_no') {
						sheet_no = this.item[i].val;
					}
				}

				let o = {};
				o.title = '车牌';
				o.sheet_no = sheet_no;
				o.flag = '已提交';
				o.sel_action = 'exp_sell_car_file';
				o.upd_action = 'exp15_sell_car_file';
				o.file_action = 'sell_car_info';
				o.p1 = 'sellcar';
				o.p2 = sheet_no;

				o.list_action = '_base_sellfile';

				let that = this;
				this.$nextTick(function() {
					that.$refs['itemmode'].showpop(o);
				});


			},
			edit_mode_client: function() {

				let sheet_no = '',
					flag = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'client_name') {
						sheet_no = this.item[i].val;
					}
				}

				let o = {};
				o.title = '客户';
				o.sheet_no = sheet_no;
				o.flag = '已提交';
				o.sel_action = 'exp_sell_car_clientfile';
				o.upd_action = 'exp15_sell_car_file';
				o.file_action = 'sell_car_info';
				o.p1 = 'selluser';
				o.p2 = sheet_no;

				o.list_action = '_base_userfile';

				let that = this;
				this.$nextTick(function() {
					that.$refs['itemmode'].showpop(o);
				});



			},
			edit_mode_file: function() {

				let sheet_no = '',
					flag = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
					if (this.item[i].key == 'flag') {
						flag = this.item[i].val;
					}
				}

				let o = {};
				o.title = '单号';
				o.sheet_no = sheet_no;
				o.flag = flag;
				o.sel_action = 'exp_sell_car_sheetfile';
				o.upd_action = 'exp15_sell_car_file';
				o.file_action = 'sell_car_info';
				o.p1 = 'sellcar';
				o.p2 = sheet_no;

				o.list_action = '_base_sheetfile';

				let that = this;
				this.$nextTick(function() {
					that.$refs['itemmode'].showpop(o);
				});


			},



		}
	};
</script>
<style>
</style>